import {
  ASSET_SEARCH_SOURCE,
  ASSET_VERIFIED,
  type AssetSearchSource,
  type AssetVerified,
} from '../types';

export const resolveAssetSearchSources = ({
  verified,
  supportsUnverified,
}: {
  verified: AssetVerified;
  supportsUnverified: boolean;
}): AssetSearchSource[] => {
  if (!supportsUnverified) {
    return verified === ASSET_VERIFIED.NO ? [] : [ASSET_SEARCH_SOURCE.VERIFIED];
  }

  return verified === ASSET_VERIFIED.NO
    ? [ASSET_SEARCH_SOURCE.UNVERIFIED]
    : [ASSET_SEARCH_SOURCE.VERIFIED];
};
